import { type ReactNode } from 'react';

type Props = {
  agreed: boolean;
  onToggle: () => void;
  error?: string | undefined;
};

function LegalLink({
  href,
  label,
}: {
  href: string;
  label: string;
}): ReactNode {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="underline text-text-primary"
      onClick={(e) => e.stopPropagation()}
    >
      {label}
    </a>
  );
}

function CheckboxRow({ agreed, onToggle }: Omit<Props, 'error'>): ReactNode {
  return (
    <label className="flex items-start gap-sm text-xs text-text-secondary cursor-pointer">
      <input
        type="checkbox"
        checked={agreed}
        onChange={onToggle}
        className="mt-0.5 accent-brand-red"
      />
      <span>
        He le&iacute;do y acepto los{' '}
        <LegalLink href="/terms" label="términos" />
        {' y la '}
        <LegalLink href="/privacy" label="política de privacidad" />
      </span>
    </label>
  );
}

export function LegalCheckbox({ error, ...rest }: Props): ReactNode {
  return (
    <div>
      <CheckboxRow {...rest} />
      {error && <p className="mt-xs text-xs text-error">{error}</p>}
    </div>
  );
}
